export const PRO_BENEFITS = [
  'Build on large Mac and Linux machines',
  'Reuse dependencies between builds',
  'Concurrencies: 10 macOS, 30 Linux',
  'Run long builds without timeouts',
  'Unlimited Steps and Projects',
  'More builds every month',
];
